import React from 'react';
import { PaintRollerIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { ui } from '../data/ui';
export function Logo() {
  const {
    t
  } = useLanguage();
  return <span className="flex items-center gap-2.5" data-id="element-254" data-mp="3qacofm8obu1k">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-leaf-strong" data-id="element-255" data-mp="3q7qexh2834gp">
        <PaintRollerIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-256" data-mp="3v6bf5ghh5o55" />
      </span>
      <span className="flex flex-col leading-none" data-id="element-257" data-mp="mqrpssjxcpvd">
        <span className="font-display text-xl font-extrabold tracking-tight text-white" data-id="element-258" data-mp="rs7a2iea2scp">
          WIN<span className="text-leaf-light" data-id="element-259" data-mp="dsxwzrldcecy">21</span>DER
        </span>
        <span className="mt-1 hidden whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.08em] text-navy-soft sm:block" data-id="element-260" data-mp="htriyff93j37">
          {t(ui.tagline)}
        </span>
      </span>
    </span>;
}